<template lang="pug">
  menu-item(:label=`$t('ssp_color')`, keybind="C", v-model="module.showParamsWindow")
</template>


<script lang="ts">
import Vue from 'vue'
export default Vue.extend({
  props: {
    module: { required: true },
  },
})
</script>


<i18n>
en:
  ssp_color: SSP Color
ja:
  ssp_color: SSP色調整

</i18n>